// services/placeOrderServices.js
import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

const placeOrderUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.placeOrder}`;
const OrderUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.order}`;

export const placeOrder = async (orderData) => {
  try {
    const response = await axios.post(placeOrderUrl, orderData, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data.data.orders;
  } catch (error) {
    console.log("Error place order: ", orderData);
    throw error.response?.data;
  }
};

export const fetchOrder = async () => {
  try {
    const response = await axios.get(OrderUrl, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data.data;
  } catch (error) {
    throw error.response?.data || "Something went wrong!";
  }
};

export const updateOrderStatus = async (id, status) => {
  try {
    const response = await axios.put(
      `${OrderUrl}/${id}`,
      { status },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    return response.data; // ✅ Axios automatically parses JSON
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update order");
  }
};
